import React, {
  useState,
  useRef,
  useMemo,
} from 'react';
import {
  Row,
  Col,
  Modal,
  Input,
  Spin,
} from 'antd';
import debounce from 'lodash.debounce';
import SimpleReactValidator from 'simple-react-validator';
import { SpH5 } from 'components/DesignKit';

type Props = {
  modalVisibility: Boolean,
  setModalVisibility: Function,
  addNewLocation: Function,
  lynxConnectLoading: Boolean,
}

const AddNewLynxConnectLocation = (props: Props) => {
  const {
    modalVisibility,
    setModalVisibility,
    addNewLocation,
    lynxConnectLoading,
  } = props;

  const debouncedAddNewLocation = useMemo(() => (
    debounce(addNewLocation, 1000, { leading: true })
  ), [addNewLocation]);

  const [newLynxConnectLocation, setNewLynxConnectLocation] = useState({
    gid: null,
    name: null,
    address: null,
    lynxLocationId: null,
  });
  const [, forceStateUpdate] = useState(0);
  const validator = useRef(new SimpleReactValidator());

  const handleModalCancel = () => {
    if (lynxConnectLoading) {
      return;
    }
    setNewLynxConnectLocation({
      // gid: null,
      name: null,
      // address: null,
      lynxLocationId: null,
    });
    validator.current.hideMessages();
    setModalVisibility(false);
  };

  const handleModalSave = () => {
    if (validator.current.allValid()) {
      const sanitizedNewLynxConnectLocation = {};
      // sanitizedNewLynxConnectLocation.gid = newLynxConnectLocation.gid.trim();
      sanitizedNewLynxConnectLocation.name = newLynxConnectLocation.name.trim();
      // sanitizedNewLynxConnectLocation.address = newLynxConnectLocation.address.trim();
      sanitizedNewLynxConnectLocation.lynxLocationId = newLynxConnectLocation.lynxLocationId.trim();
      debouncedAddNewLocation(sanitizedNewLynxConnectLocation);
      validator.current.hideMessages();
      setModalVisibility(false);
      setNewLynxConnectLocation({
        // gid: null,
        name: null,
        // address: null,
        lynxLocationId: null,
      });
    } else {
      validator.current.showMessages();
      forceStateUpdate(state => (state === 0 ? state + 1 : state - 1));
    }
  };

  const handleNewLynxLocationInfo = (fieldName, value) => {
    setNewLynxConnectLocation(state => ({
      ...state,
      [fieldName]: value,
    }));
  };

  return (
    <Modal
      title="Add Location"
      visible={modalVisibility}
      onOk={handleModalSave}
      onCancel={handleModalCancel}
      centered
      maskClosable={false}
    >
      <Spin
        spinning={lynxConnectLoading}
        tip="Please wait..."
        size="large"
        delay={300} // delay in ms to avoid flicker
      >
        <div style={{ padding: '16px' }}>
          <Row gutter={16}>
            {/* <Col span={12}>
              <label>
                <SpH5>GID</SpH5>
              </label>
              <Input
                name="lynxConnectNewLocationGid"
                value={newLynxConnectLocation.gid ?? ''}
                onChange={(e) => handleNewLynxLocationInfo('gid', e.target.value)}
              />
              <section style={{ color: 'red' }}>
                { validator.current.message('lynxConnectNewLocationGid', newLynxConnectLocation.gid, 'required') }
              </section>
            </Col> */}
            <Col span={24}>
              <label>
                <SpH5>Name</SpH5>
              </label>
              <Input
                name="lynxConnectNewLocationName"
                value={newLynxConnectLocation.name ?? ''}
                onChange={(e) => handleNewLynxLocationInfo('name', e.target.value)}
              />
              <section style={{ color: 'red' }}>
                { validator.current.message('lynxConnectNewLocationName', newLynxConnectLocation.name, 'required') }
              </section>
            </Col>
          </Row>

          {/* <Row gutter={16} style={{ marginTop: 16 }}>
            <Col span={24}>
              <label>
                <SpH5>Address</SpH5>
              </label>
              <Input
                name="lynxConnectNewLocationAddress"
                value={newLynxConnectLocation.address ?? ''}
                onChange={(e) => handleNewLynxLocationInfo('address', e.target.value)}
              />
              <section style={{ color: 'red' }}>
                { validator.current.message('lynxConnectNewLocationGid', newLynxConnectLocation.address, 'required') }
              </section>
            </Col>
          </Row> */}

          <Row gutter={16} style={{ marginTop: 16 }}>
            <Col span={24}>
              <label>
                <SpH5>Lynx Location ID</SpH5>
              </label>
              <Input
                name="lynxConnectNewLocationId"
                value={newLynxConnectLocation.lynxLocationId ?? ''}
                onChange={(e) => handleNewLynxLocationInfo('lynxLocationId', e.target.value)}
              />
              <section style={{ color: 'red' }}>
                { validator.current.message('lynxConnectNewLocationId', newLynxConnectLocation.lynxLocationId, 'required') }
              </section>
            </Col>
          </Row>
        </div>
      </Spin>
    </Modal>
  );
};

export default AddNewLynxConnectLocation;
